import { useDispatch, useSelector } from 'react-redux';
import { fetchAgeRange, updateAgeRange as updateAgeRangeAction, addAgeRange } from '../../../redux/resources/resourcesSlice';
import { useCallback } from 'react';
import { RootState } from '../../../redux';    
import { AppDispatch } from '../../../redux';

// Hook for fetching age ranges
const useFetchAgeRange = () => {
  const dispatch = useDispatch<AppDispatch>();
  
  const { ages, isLoading, error } = useSelector(
    (state: RootState) => state.resources
  );

  const fetchAgeRanges = useCallback(async () => {
    try {
      await dispatch(fetchAgeRange()).unwrap();
    } catch (error) {
      console.error('Failed to fetch age ranges:', error);
      throw error;
    }
  }, [dispatch]);

  return {
    ages,
    isLoading,
    error,
    fetchAgeRanges
  };
};

// Hook for adding new age range
const useAddAgeRange = () => {
  const dispatch = useDispatch<AppDispatch>();
  
  const { isLoading, error } = useSelector(
    (state: RootState) => state.resources
  );

  const addNewAgeRange = useCallback(async (ageRangeData: any) => {
    try {
      const result = await dispatch(addAgeRange(ageRangeData)).unwrap();
      return result;
    } catch (error) {
      console.error('Failed to add age range:', error);
      throw error;
    }
  }, [dispatch]);

  return {
    addNewAgeRange,
    isLoading,
    error
  };
};

// Hook for updating age range
const useUpdateAgeRange = () => {
  const dispatch = useDispatch<AppDispatch>();
  
  const { isLoading, error } = useSelector(
    (state: RootState) => state.resources
  );

  const updateExistingAgeRange = useCallback(async (id: string, ageRangeData: any) => {
    try {
      const result = await dispatch(updateAgeRangeAction({ id, data: ageRangeData })).unwrap();
      return result;
    } catch (error) {
      console.error('Failed to update age range:', error);
      throw error;
    }
  }, [dispatch]);

  return {
    updateExistingAgeRange,
    isLoading,
    error
  };
};

//TODO: Add delete age range later
// const deleteAgeRange = () => {

// }

export {
  useFetchAgeRange,
  useAddAgeRange,
  useUpdateAgeRange // Fixed export name
};
